import { atom } from 'recoil'
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist()

export const userState = atom({
  key: 'user',
  default: {
    id: 0,
    name: '',
    employeeId: null,
  },
  effects_UNSTABLE: [persistAtom],
})

export const userAuthStatus = atom({
  key: 'userAuthStatus',
  default: {
    studioName: '',
    studioNameKo: '',
    teamName: '',
    teamNameKo: '',
  },
  effects_UNSTABLE: [persistAtom],
})
